import Vue from 'vue'
import Vuex from 'vuex'
import state from './default/state'
import actions from './default/actions'
import mutations from './default/mutations'
import i18nState from './i18n/state'
import i18nActions from './i18n/actions'
import i18nMutations from './i18n/mutations'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    i18n: {
      namespaced: true,
      state: i18nState,
      actions: i18nActions,
      mutations: i18nMutations
    },
    default: {
      namespaced: true,
      state,
      actions,
      mutations
    }
  }

})
